import * as React from "react";
import { createOverlayId, registerOverlay } from "@/lib/overlayHistory";

export function withBackClose(PrimitiveRoot) {
  function HistoryAwareRoot({ open: controlledOpen, defaultOpen = false, onOpenChange, ...props }) {
    const [uncontrolledOpen, setUncontrolledOpen] = React.useState(defaultOpen);
    const open = controlledOpen === undefined ? uncontrolledOpen : controlledOpen;
    const id = React.useRef(null);
    if (id.current === null) id.current = createOverlayId();

    const changeOpen = React.useCallback((nextOpen) => {
      if (controlledOpen === undefined) setUncontrolledOpen(nextOpen);
      onOpenChange?.(nextOpen);
    }, [controlledOpen, onOpenChange]);
    const changeOpenRef = React.useRef(changeOpen);
    changeOpenRef.current = changeOpen;

    React.useLayoutEffect(() => {
      if (!open) return undefined;
      return registerOverlay(id.current, () => changeOpenRef.current(false));
    }, [open]);

    return <PrimitiveRoot {...props} open={open} onOpenChange={changeOpen} />;
  }

  HistoryAwareRoot.displayName = `HistoryAware${PrimitiveRoot.displayName || "Overlay"}`;
  return HistoryAwareRoot;
}
